var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgWellnessLeaf = function SvgWellnessLeaf(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 30 30",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wellness_leaf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "M18.6 15.3c2.25-2.25 5.4-3.6 8.7-3.6 0 3.3-1.35 6.45-3.6 8.7S18.3 24 15 24m0 0c-3.3 0-6.45-1.35-8.7-3.6S2.7 15 2.7 11.7c3.3 0 6.45 1.35 8.7 3.6M15 24c-2.4-2.4-3.75-5.55-3.75-8.85S12.6 8.7 15 6.3c2.4 2.4 3.75 5.55 3.75 8.85S17.4 21.6 15 24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wellness_leaf_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWellnessLeaf);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;